import { LogLevel } from "@azure/msal-browser";

/**
 * MSAL Configuration for Azure AD SSO
 * Configuration values are loaded from public/config.js
 * 
 * See FIND_TENANT_ID.md for instructions on finding your Tenant ID
 */

// Get configuration from window.azureadconfig (loaded from public/config.js)
const clientId = window.azureadconfig?.clientId;
const tenantId = window.azureadconfig?.tenantId;
const redirectUri = window.azureadconfig?.redirectUri;
const postLogoutRedirectUri = window.azureadconfig?.postLogoutRedirectUri || redirectUri;

// Validate required configuration
if (!clientId) {
  console.error("❌ clientId is not configured. Please update public/config.js with your Azure AD Application ID.");
}

if (!tenantId) {
  console.error("❌ tenantId is not configured. Please update public/config.js with your Azure AD Tenant ID.");
}

// Build authority URL based on tenant
const authority = tenantId 
  ? `${window.azureadconfig?.authorityURL}${tenantId}`
  : window.azureadconfig?.optionalAuthorityURL;

const msalConfig = {
  auth: {
    clientId: clientId,
    authority: authority,
    redirectUri: redirectUri,
    postLogoutRedirectUri: postLogoutRedirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "memory", // Use memory storage for security (don't persist tokens to disk)
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
          case LogLevel.Info:
          case LogLevel.Verbose:
          case LogLevel.Warning:
          default:
            return;
        }
      },
      piiLoggingEnabled: false
    }
  }
};

/**
 * Token request scopes
 * These scopes define what permissions the app is requesting from Azure AD
 */
export const loginRequest = {
  scopes: ["user.read", "email", "profile"],
  redirectUri: window.azureadconfig?.redirectUri
};

/**
 * Graph API scopes for additional requests
 */
export const graphRequest = {
  scopes: ["user.read"]
};

export { msalConfig };
